import { Box } from 'reflexbox';
import * as graphql from 'generated/graphql';
import SettingsItem from 'packages/kakapo-ui-settings-application/pages/generic/SettingsItem';
import useLocalize from 'packages/kakapo-ui-application/hooks/useLocalize';
import GoalListItemCompetency from 'packages/kakapo-ui-kit/components/goals/list/GoalListItemCompetency';
import { useHistory } from '@treams/treams-routes';

export default function GoalTemplateRow(props: {
	jobTitle: graphql.JobTitle;
	goalTemplate: graphql.GoalTemplate;
}) {
	const history = useHistory();
	const { localize } = useLocalize();

	return (
		<>
			<SettingsItem
				item={props.goalTemplate as any}
				title={(template: graphql.GoalTemplate) => localize(template.title).text}
				onEdit={() => history.push(`/settings/goals/${props.goalTemplate.id}`)}
				onRefresh={() => {}}
			>
				{props.goalTemplate.competency && (
					<Box mt={3}>
						<GoalListItemCompetency competency={props.goalTemplate.competency}/>
					</Box>
				)}
			</SettingsItem>
		</>
	);
}
